import { createSlice } from "@reduxjs/toolkit";

export const MOBILE_VIEWPORT_QUERY = "(max-width: 767.98px)";

// Keep the server and the first client render consistent. AppContainer updates
// this value from the viewport once the app has mounted.
const initialState = { device: "pc" };

export const deviceSlice = createSlice({
	name: "device",
	initialState,
	reducers: {
		setDevice: (state, action) => {
			state.device = action.payload;
		},
	},
});

export const { setDevice } = deviceSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state.
export const selectDevice = (state) => state.device.device;

export default deviceSlice.reducer;